import { useEffect, useLayoutEffect } from 'react';

import { fg } from '@confluence/feature-gating';
import { useCommentsPanelState } from '@confluence/comments-panel-utils';

import {
	legacyUpdateVisibleReplies,
	updateVisibleReplies,
	type LegacyUpdateVisibleRepliesProps,
	type UpdateVisibleRepliesProps,
} from '../helper/commentThreadHelper';

export const useUpdateVisibleReplies = ({
	allReplies,
	commentType,
	isParentCommentOpen,
	currentReplyView,
	latestReplies,
	latestReplyIds,
	parentCommentId,
	setVisibleReplies,
	shouldShowLatestReplies,
	numOfHiddenReplies,
	allowNestedReplies = false,
}: LegacyUpdateVisibleRepliesProps & UpdateVisibleRepliesProps) => {
	// As long as the flag is present, we have to provide both
	const { currentView } = useCommentsPanelState();

	useLayoutEffect(() => {
		if (!fg('confluence_frontend_cp_visible_replies_refactor')) return;

		updateVisibleReplies({
			parentCommentId,
			currentReplyView,
			setVisibleReplies,
			allReplies,
			isParentCommentOpen,
			latestReplies,
			currentView,
			allowNestedReplies,
		});
	}, [
		allReplies,
		currentReplyView,
		isParentCommentOpen,
		latestReplies,
		numOfHiddenReplies,
		parentCommentId,
		setVisibleReplies,
		currentView,
		allowNestedReplies,
	]);

	useEffect(() => {
		if (fg('confluence_frontend_cp_visible_replies_refactor')) return;

		legacyUpdateVisibleReplies({
			allReplies,
			commentType,
			isParentCommentOpen,
			currentReplyView,
			latestReplies,
			latestReplyIds,
			parentCommentId,
			setVisibleReplies,
			shouldShowLatestReplies,
			numOfHiddenReplies,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps -- there might be a better way to handle this without needing a useEffect
	}, [allReplies, latestReplies, latestReplyIds]);
};
